import { ClientCard, Cover, Header, Main } from 'components';
import { useAuth } from 'hooks/useAuth';
import React, { useEffect, useState } from 'react';
import { services } from 'static';
import { CoverData } from 'types';

import { Section, SpecsSection } from './styles';

export const VirtualCard: React.FC = () => {
  const { user } = useAuth();
  const [coverContent, setCoverContent] = useState<CoverData>({} as CoverData);

  useEffect(() => {
    setCoverContent(
      services.filter(({ slug }) => slug === '/saude/cartao').shift()?.cover || ({} as CoverData)
    );
  }, []);

  return (
    <>
      <Header />
      <Main>
        <Cover {...coverContent} />
        <Section>
          <ClientCard name={user.name} card_number={user.insurance_card} />
          <span className="sub-title">Cartão de cliente</span>
          <p>Para ver os seus dados no verso toque no cartão</p>
        </Section>
        <SpecsSection>
          <h2>Condições do Seguro</h2>
          <p>
            Urgentemente de espolinhar-se na relva, beber «no fio dos regatos, e dormir balançada
            num ramo de castanheiro. O solicito «Baptiste que me remeta amanhã pelo ónibus a mala
            com que eu não quis «sobrecarregar a tropia do Mulato. Eu demoro-me apenas três ou
            quatro «dias. O tempo de cavaquear um bocado com o Absoluto no alto dos «Capuchos, e ver
            o que estão fazendo os miosótis junto à meiga fonte dos Amores...»
          </p>
          <h2>Inclui:</h2>
          <p>
            Arrastou Carlos: e pelo Chiado abaixo falou-lhe logo do Dâmaso. Não tornara a ver essa
            flor? Pois essa flor andava apregoando por toda a parte que o Maia, depois do caso do
            Chiado, lhe dera por um amigo explicações humildes, covardes... Terrível, aquele Dâmaso!
            Tinha figura, interior, e natureza de pela! Com quanto mais força se atirava ao chão,
            mais ele ressaltava para o ar, triunfante!...
          </p>
        </SpecsSection>
      </Main>
    </>
  );
};
